import { useState } from "react";
import {getHelpByField} from '../services/helpService';

export const useHelp = () => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState([]);

  const fetchHelp = async (formName, fieldName) => {
    try {
      const res = await getHelpByField([formName,fieldName]);
      setContent(res.data || []);
      setShow(true);
    } catch (err) {
      console.error("Gagal ambil help:", err);
    }
  };

  return { show, setShow, content, fetchHelp };
};
